<template>
  <a-modal
      title="达人授权"
      :visible="visible"
      @cancel="onCancel"
      :footer="null"
      :width="725"
  >
    <div class="auth-cnt">
      <div class="permissions">
        <div class="title">
          <span class="app">{{title}}</span>
          将获得以下权限
        </div>
        <div v-for="(desc, i) in permission" :key="'permission_' + i" class="permission-item">
          <div class="tag"></div>
          <div>{{ desc }}</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="login">
        <div class="title">快捷安全登录</div>
        <div class="desc">使用<span style="color: #ff4242;">APP</span>扫码授权</div>
        <img v-if="qrcode.startsWith('http://') || qrcode.startsWith('https://')" class="qrcode" :src="qrcode"/>
        <img v-else class="qrcode" :src="'data:image/png;base64,' + qrcode"/>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      visible: false,
      title: '',
      permission: [],
      qrcode: '',
    }
  },
  methods: {
    show(title, permission, qrcode) {
      this.title = title
      this.permission = permission
      this.qrcode = qrcode
      this.visible = true
    },
    onCancel() {
      this.visible = false
      this.$emit('onCancel')
    }
  },

}
</script>

<style scoped lang="scss">
.auth-cnt {
  display: flex;

  .permissions {
    flex-grow: 1;
    padding: 20px 40px;
    max-width: 400px;
    max-height: 300px;
    overflow-y: auto;

    .title {
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      margin-bottom: 10px;

      .app {
        margin-left: 4px;
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
      }
    }

    .permission-item {
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      display: flex;
      margin-bottom: 10px;

      .tag {
        width: 6px;
        height: 6px;
        background: #70CC20;
        margin-right: 8px;
        margin-left: 7px;
        margin-top: 7px;
      }
    }
  }

  .line {
    width: 2px;
    height: 275px;
    background: #F6F6F6;
  }

  .login {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;

    .title {
      font-size: 18px;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
    }
    .desc {
      margin-top: 10px;
      font-size: 14px;
      color: #ABABAB;
      line-height: 20px;
    }
    .qrcode {
      margin-top: 26px;
      width: 160px;
      height: 160px;
      background: #FFFFFF;
      border-radius: 12px;
      border: 1px solid #DDDDDD;
    }
    .switch {
      margin-top: 26px;
      font-size: 14px;
      color: #ff4242;
      line-height: 20px;
      cursor: pointer;
    }
  }

}
</style>
